import { useContext } from 'react';
import {
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Link
} from '@mui/material';
import { Correct } from '@abbott-components/icons';
import KebabMenu from './KebabMenu';
import { WorkflowEngineContext } from '../../WorkflowEngine/workflowEngineReducer';

const PublishedView = ({
  handleOpenPublishDialog
}: {
  handleOpenPublishDialog: () => void;
}) => {
  const { state } = useContext(WorkflowEngineContext);

  const { versionData } = state;

  return versionData ? (
    <>
      <Grid item sx={{ display: 'inline-flex', alignItems: 'center' }}>
        <List>
          <ListItem>
            <ListItemIcon>
              <Correct
                sx={{
                  paddingLeft: '25px',
                  fontSize: '22px',
                  paddingBottom: '10px'
                }}
              />
            </ListItemIcon>
            <ListItemText
              primary={`Published on ${new Date(
                versionData?.datePublished as string
              ).toDateString()}`}
              secondary={
                <Link
                  component="button"
                  variant="subtitle2"
                  onClick={handleOpenPublishDialog}
                  sx={{ fontSize: '14px', paddingTop: '0px' }}
                >
                  View more
                </Link>
              }
            />
          </ListItem>
        </List>
      </Grid>
      <Grid item>
        <KebabMenu />
      </Grid>
    </>
  ) : null;
};

export default PublishedView;
